module.exports = {
  hd: {
    login: '登录',
    register: '注册',
    announcement: '公告',
    game: '游戏',
    otc: '法币交易',
    capital: '资产',
    transaction: '场外交易',
    currency: '币币交易',
    currencyMall: '交易中心',
    co: '合约交易',
    coCenter: '合约大厅',
    home: '首页',
    userCenter: '个人中心',
    orderManage: '订单',
    apiManage: '我的API',
    ask: '发起提问',
    logout: '退出',
    chaindown: '商务合作',
    economic: '经济人管理',
    adcenter_def: '普通交易',
    adcenter_big: '大宗交易',
    mining: '挖矿交易',
    invitation: '邀请分红',
    msgcenter: '消息中心',
    set: '设置',
    otc_trade: "OTC交易",
    c2c_trade: "C2C交易"
  },
  // 底部
  ft: {
    tickets: "提交工单",
    partners: "合作伙伴",
    weibo: "官方微博",
    qqgroup: "官方QQ群",
    telegram: "官方电报群",
    email: "官方邮箱",
    facebook: "官方脸书",
    whitepapers: "官方白皮书",
  },
  main: {
    description: "描述",
    fbdw: '法币计价单位',
    marketSet: '自选',
    allMarkets: "全部行情",
    more: '更多',
    search: '搜索',
    market: '市场',
    close: '最新价',
    rose: '涨跌',
    height: '最高价',
    low: '最低价',
    vol: '成交量',
    amount: '成交金额',
    no_data: '暂无市场信息',
    prompt: '温馨提示：数字资产是创新的投资产品，价格波动较大，具有较高的投资风险，请您投资前对数字资产充分认知，理性判断自己的投资能力，审慎做出投资决策',
    notice: '重要公告',
    deal_forehead: '成交额',
    loading_ing: '正在加载',
    theme: '主题',
    copy: "复制",
    blueTheme: '蓝色版',
    whiteTheme: '浅色版',
    blackTheme: '黑色版',
    exchangeApp: "交易所APP",
    exchangeAppIntroduce: "快速便捷的全网交易平台",
    bipayApp: "币付宝APP",
    bipayAppIntroduce: "支付、游戏、应用等一体化钱包",
    app_ios: "IOS企业版下载",
    app_ios_01: "请再次点击我去信任并安装",
    app_android: "Android版下载",
    app_h5: "免APP下载",
    app_download: 'APP下载',
    sweep_download: '扫码下载',
    download_address: "下载地址",
    download_page: "下载页面",
    app_01: "快速、便捷、安全的交易平台",
    copySuccess: "复制成功",
    getCode: "获取验证码",
    confirm: "确定",
    cancel: "取消",
    noData: "暂无数据",
    viewMore: "查看更多",
    ReleaseTime: "发布时间",
    notNull: "参数不能为空",
    sureDel: "你确定删除吗？",
    close_01: "关闭",
    NotOpen: "暂未开放",
    pleaseLogin: "请先登录",
    serverException: "服务器异常",
    unknown: "未知",
    alert_01: "点击右上角的",
    alert_02: "按钮",
    alert_03: "选择",
    alert_04: "在Safari中打开",
    alert_05: "在浏览器中打开",
    optional: "选填"
  },
  user: {
    announcement: '公告',
    userCenter: '用户中心',
    langSetting: '语言设置',
    securityCenter: '安全中心',
    versionUpdates: '版本更新',
    monetaryUnitSetting: '货币单位设置',
    currencySet: '币种设置',
    aboutUs: '关于我们',
    share: '分享我们',
    loginRegister: '登录/注册',
    logout: '注销登入',
    money: "我的资金",
    deal: "我的交易",
    myOrder: "我的挂单",
    dealHistory: "成交记录",
    lock: "锁仓管理",
    lockHistory: "锁仓记录",
    releaseHistory: "释放记录",
    financial: "财务记录",
    certification: "实名认证",
    security: "安全中心",
    recommended: "推荐计划",
    workorder: "工单管理",
    bankcard: "支付绑定",
    personal: '个人信息',
  },
  // 首页
  home: {
    next: '创业区',
    favorites: "自选区",
    markets: "交易区",
    performer: '涨幅榜',
    DropList: '跌幅榜',
    transferAccounts: '转账',
    ExpertsToShare: '专家分享',
    service: '客服',
    share: '分享',
    SaveMoneyLive: "存币生息",
    CurrencyTraders: '币商',
    experienceImmediately: '立即体验',
    shares: '登陆后才可以分享哦',
    copysuc: '分享链接复制成功',
    nonsupport: '该浏览器不支持自动复制',
    classify: "分类",
    text_01: "开启之后可以选择币种分类,关闭即可恢复默认列表",

  },
  // 交易中心
  trade: {
    latestPrice: '最新价',
    highestPrice: '最高价',
    minimumPrice: '最低价',
    applies: '涨跌幅',
    H_volume: '24H量',
    H_turnover: '24H额',
    K_line: 'K线图',
    depth_line: '深度图',
    LoginAccount: '登录账户',
    liquidity: '让资产流动起来',
    totalAssets: '净资产折合',
    marketSet: '自选',
    searchSymbols: '查找币种',
    symbols: '币种',
    noSymbols: '暂无货币',
    latestDeal: '最新成交',
    coin: "币种",
    time: '时间',
    price: '价格',
    amount: '数量',
    money_01: "资金",
    dealVolume: '成交量',
    dealAmount: '成交额',
    action: "操作",
    maker: "挂单",
    taker: "吃单",
    type: "类型",
    buy: '买入',
    sell: '卖出',
    buy_d: '买',
    sell_d: '卖',
    available: '可用',
    marketPrice: '市价',
    limitPrice: '限价',
    mergeDepth: '合并深度',
    total: '累计',
    dealDepth: '买卖深度',
    buyDepth: '买盘深度',
    sellDepth: '卖盘深度',
    entrustTime: '时间',
    entrustType: '类别',
    entrustPrice: '价格',
    entrustNumber: '数量',
    entrustMoney: '总额',
    dealMoney: '交易额',
    averagePrice: '平均成交价',
    notDeal: '尚未成交',
    orderSource: '订单来源',
    status_c: '状态/操作',
    cancelOrder: '撤单',
    notData: '暂无数据',
    confirmCancelText: '您确定要撤销订单吗？',
    trade_01: "交易对，挂错价格，成功后将无法取消。",
    trade_02: "警告：当前为",
    order: "订单",
    cancel: '取消',
    confirm: '确定',
    myOrder: '我的挂单',
    myDeal: "我的成交",
    allOrder: '全部委托',
    dealHistory: '成交历史',
    c_success: '操作成功',
    mPriceBuy: '以市场上最优价格买入',
    mPriceSell: '以市场上最优价格卖出',
    money: '金额',
    buyPrice: '买入价格',
    buyNumber: '买入数量',
    buyMoney: '买入金额',
    sellPrice: '卖出价格',
    sellNumber: '卖出数量',
    sellMoney: '卖出金额',
    fillError: '输入错误',
    dealFw: '交易额超出可用范围',
    dealCussess: '下单成功',
    dealId: '成交单号',
    dealTime: '成交时间',
    dealMoneys: '成交金额',
    dealPrice: '成交价格',
    serviceCharge: '手续费',
    tradeFee: "Trade Fee",
    errorInfor_1: '请先登录账号',
    errorInfor_2: '请先输入价格',
    errorInfor_3: '没有可用的',
    errorInfor_4: '请充值',
    selectPair: "选择交易对",
    gains: "涨幅",
    drop: "跌幅",
    text_01: "成交才收，撤单退回。以实际成交的扣除为准",
    text_02: "你确定取消吗？",
    text_03: "不能小于0",
    cancelSuccess: "取消成功",
    cannotBeZero: "不能为0",

  },
  // 行情
  market: {
    main: "主板",
    next: "创业板",
    currency: '币种',
    price: '价格',
    increase: '涨幅',
    market: '行情',
    optionalArea: '自选区',
    loadingLoad: '加载中',
    noData: '暂无数据',
    "LIMIT_TRADE_BTC": "最少交易0.001BTC",
    "LIMIT_TRADE_C2C": "最少交易70元",
    "LIMIT_TRADE_ETH": "最少交易0.01ETH",
    "LIMIT_TRADE_USDT": "最少交易10USDT",
    "LIMIT_TRADE": "禁止小额订单",
  },
  // 交易所
  exchange: {
    huobi: "火币",
  },
  // 钱包
  wallet: {
    Rebind: "重新绑定",
    Account: '对方账户',
    BindAccount: "绑定账户",
    AccountType: "账户类型",
    "TransferHistory": "转账记录",
    bind_text01: "未绑定账户，请绑定",
    "bind_success": "绑定成功",
    "TimeMachine": "时光机",
    "StarCraftCapsule": "星神舱",
    walletAccount: "我的钱包",
    tradeAccount: "交易账户",
    fiatAccount: "法币账户",
    gameAccount: "游戏账户",
    EstimatedBalance: "总资产折合:",
    myWallet: '我的钱包',
    toLogin: '登入操作钱包',
    noLogin: '你还没有登入哦~',
    assetValuation: '资产估算',
    search: '输入币种名称搜索',
    usable: '可用',
    action: "操作",
    available: "可用余额",
    freeze: "冻结金额",
    total: "总量",
    lock: '锁定',
    trade: "交易",
    candy: "糖果",
    Referral: "推荐奖励",
    give: "赠送",
    into: "转入",
    wallet: "钱包",
    RollOut: "转出",
    buy: "买入",
    sell: "卖出",
    deposit: '充值',
    MentionMoney: '提币',
    withdraw: "提现",
    deal: '交易',
    transfer: '转账',
    hideBalance: "隐藏资金为0的币种",
    depositAddress: "充值地址",
    minDeposit: "最小充值",
    address: "地址",
    amount: "数量",
    selectCategory: "选择类别",
    selectCoin: "选择币种",
    startDate: "开始日期",
    to: "至",
    endDate: "结束日期",
    query: "查询",
    category: "类别",
    otherAccount: "对方账户",
    submitSuccess: "提交成功",
    transferSuccess: "转账成功",
    Transfer: "划转",
    Transfers: "划转",
    TransferCoin: "划转币种",
    TransferAmount: "划转数量",
    From: "从",
    To: "到",
    Maximum: "可划转余额:",
    TransferSuccess: "划转成功",
    Transfer_01: "超出可转余额",
    Transfer_02: "不支持的划转方式",
    valuation: "估值",
    serviceFee: "服务费",
    chain_name: "链名称",
  },
  // 交易
  buy: {
    price: '价格',
    amount: '数量',
    rental: '总额',
    availableBalance: '可用余额：',
    AllWarehouse: '全仓',
    AWarehouse: '半仓',
    warehouse: '仓',
    buy: '买入',
    sale: '卖出',
    TransactionsAreNotAllowedInThisCurrency: '该币种不允许交易',
    sell: '卖',
    purchase: '买',
    type: '类型',
    turnover: '成交数量',
    hint: '提示',
    confirm: '确定',
    cancel: '取消',
    CommissionedByTheCurrent: '当前委托',
    BidHistory: '成交记录'
  },
  // 登录
  login: {
    welcomeLogin: '欢迎登录',
    welcomeRegister: '欢迎注册',
    noAccount: '还没有账户？',
    isAccount: '已有账户?',
    register: '注册',
    phoneOrEmail: "请输入手机号或邮箱",
    code: "验证码",
    login: '登录',
    loginIng: '正在登录',
    registerIng: '正在注册',
    submitIng: '正在提交',
    switchimg: "看不清？换一张",
    resend: "秒后可重发",
    allNationalities: "全部国籍",
    commonlyUsed: "常用",
    forgetPassword: '忘记密码',
    cancel: '取消',
    confirm: '确定',
    password: '密码',
    loginCuccess: '登录成功',
    registerCuccess: '注册成功',
    registerMobile: "手机注册",
    registerEmail: "邮箱注册",
    phoneNumber: "手机号",
    text_01: '使用手机号注册',
    text_02: '使用邮箱注册',
    text_03: '我已阅读并同意服务条款',
    text_04: '服务条款',
    text_05: '隐私保护',
    text_06: '请阅读并同意服务条款',
    text_07: '请输入同时含有数字和字母，且长度在8-16位之间的密码',
    text_08: '国籍信息注册后不可修改，请务必如实选择！',
    text_09: "邮箱",
    text_10: "参数不能为空",
    confirmPassword: '确认密码',
    retrievePas: '找回密码',
    phoneRetrieve: '手机找回',
    emailRetrieve: '邮箱找回',
    lastStep: '上一步',
    nextStep: '下一步',
    pasSetCuc: '密码设置完成',
    error_500: '服务器开小差了，请稍后重试',
    verification: '验证方式',
    default: '使用默认验证方式',
    email: '邮箱验证',
    phone: '手机验证',
    google: '谷歌验证',
    retpass: '正在找回密码',
    inputcorrect: '请输入正确的邮箱或手机号',
    inputnull: '请输入邮箱或手机号',
    inputcode: '请输入验证码',
    inputcodeerror: '验证码输入错误',
    newpass: '新密码',
    passnull: '密码不能为空',
    chars: '请输入密码，8-20个非空白字符',
    surepass: '确认密码',
    againpass: '请再次输入密码',
    nopass: '两次输入密码不一致',
    forgots: '找回密码',
    passwordResetS: "密码重置成功",
    changepass: '密码修改成功',
    perfect: '请完善信息',
    signs: '注册新的会员账户',
    userName: '请输入用户名，3-20位字符',
    signaccount: '注册账户',
    send: '发送',
    codenull: '请输入验证码',
    setpass: '请设置登入密码',
    referrer: '推荐码',
    mustreferrer: '推荐码（必填）'
  },
  // 找回密码
  forgot: {
    retpass: '正在找回密码',
    inputcorrect: '请输入正确的邮箱或手机号',
    inputnull: '请输入邮箱或手机号',
    inputcode: '请输入验证码',
    newpass: '新密码',
    passnull: '密码不能为空',
    chars: '请输入密码，8-20个非空白字符',
    surepass: '确认密码',
    againpass: '请再次输入密码',
    nopass: '两次输入密码不一致',
    forgots: '找回密码',
    changepass: '密码修改成功',
    perfect: '请完善信息'
  },
  // 注册
  sign: {
    userName: '请输入用户名，3-20位字符',
    usernameerror: "请输入用户名，3-20个非空白字符",
    chars: '请输入密码，8-20个非空白字符',
    inputnull: '请输入邮箱或手机号',
    signs: '注册新的会员账户',
    name: '请输入用户昵称',
    signaccount: '注册账户',
    send: '发送',
    codenull: '请输入验证码',
    setpass: '请设置登入密码',
    referrer: '推荐码（非必填）',
    mustreferrer: '推荐码（必填）',
    referrernull: "推荐码不能为空",
    inputcorrect: '请输入正确的邮箱或手机号',
    inputcode: '请输入验证码',
    newpass: '新密码',
    passnull: '密码不能为空',
    surepass: '确认密码',
    againpass: '请再次输入密码',
    nopass: '两次输入密码不一致',
    forgots: '找回密码',
    changepass: '密码修改成功',
    inputcodeerror: '验证码输入错误',
  },
  // c2c交易
  c2c: {
    "PLEASE_VERIFY_YOUR_REALNAME": "请先实名认证",
    deal: '交易',
    tradingRecord: '交易记录',
    need: '需要',
    price: "价格",
    amount: "数量",
    time: "时间",
    action: "操作",
    type: "类型",
    orderID: "订单号",
    ToBuyImmediately: '立即买入',
    acquirability: '可得',
    ImmediatelySell: '立即卖出',
    purchases: '买入量',
    BuyQuantity: '买入量',
    SellQuantity: '卖出量',
    TradeShow: '买卖说明',
    explain_1: '买卖商户均为实地考察认证商户，并提供100万的USDT保证金，您每次兑换会冻结商户资产，商户资产不够时，不能接单，可放心兑换',
    explain_2: '买卖商户均为实名认证商户，并提供保证金，可放心兑换',
    explain_3: '请使用本人绑定的银行卡进行汇款，其他任何方式汇款都会退款。（禁止微信和支付宝）',
    explain_4: '商家处理时间9:00 - 21:00非处理时间的订单会在第二天9:00开始处理，一般接单后24小时内会完成打款',
    explain_5: '单天最多只能发起5笔未处理充值订单。',
    unitPrice: '单价',
    paymentInformation: '付款信息',
    orderInformation: "订单信息",
    moneyOrder: '汇款订单',
    ServiceProvider: "服务商信息",
    success: '成功',
    unfinished: "未完成",
    canceledCanc: '已取消',

    unconfirmed: "待确认",
    inhand: '处理中',
    haveExpired: '已过期',
    unpaid: '待支付',
    fBnak: "服务商开户行",
    fNumber: "服务商账号",
    name: '收款方户名',
    oBnak: '收款方开户行',
    number: '收款方账号',
    txt: '汇款时备注内容',
    must: '(请务必填写)',
    mobile: '收款方手机号码',
    HaveTransfer: '已转账',
    cancel: '取消订单',
    back: '返回',
    CancelWithdrawal: '取消提现',
    ToTransfer: '待转账',
    overdue: '过期',
    service: '服务商户名',
    snum: '服务商手机号',
    tacount: '转账金额',
    state: "状态",
    ordercancel: '订单已取消',
    orderdispose: '订单已提交处理',
    copysuccess: '复制成功',
    surecancel: '确定要取消吗?',
    depositsuccess: '提现成功，请等待服务商处理',
    untreated: '未处理',
    text_01: "数量不能大于余额",
    text_02: "请按提示信息向该卖家汇款",
    text_03: "（禁止使用支付宝和微信）",
    remark: "转账备注",
    required: "必填",
    WaitingTransfer: "待转账",
    buy_text01: "买入数量必须是100的倍数",
  },
  otc: {
    AppealedOrders: "已申诉订单",
    report: "我要申诉",
    openOtc: "开通OTC",
    otcRules: "申请开通OTC条件",
    buy: '买入',
    sell: '卖出',
    lastPrice: "实时价",
    high: "最高价",
    low: '最低价',
    merchant: "商家",
    merchantList: "商家列表",
    orderList: "订单列表",
    tradePrice: "估价",
    buyByAmount: "按数量购买",
    buyByVol: "按金额购买",
    sellByAmount: "按数量出售",
    sellByVol: "按金额出售",
    buyPl: "请输入购买总额",
    prompt_01: "必须本人账户支付",
    availableBalance: "可用余额",
    paymentMethod: "支付方式",
    PaymentCollection: "收款方式",
    bankTransfer: "银行卡",
    alipay: "支付宝",
    weixin: "微信",
    tradeOrder: "普通交易",
    t_seller: "商家",
    limits: "限额",
    t_buy: "购买",
    t_sell: "出售",
    trade: "交易",
    minimumAmount: "单笔最小交易量",
    maxmumAmount: "单笔最大交易量",
    fee: "手续费",
    total: '总额',
    order_text01: "买家账户信息",
    order_text02: "请选择以下方式给卖家付款",
    order_text03: "切勿备注“比特币”,'虚拟币'等信息请留意与对方实名是否一致",
    order_text04: "确认对订单进行以下操作？",
    order_text05: "务必查看是否已收到相应款项",
    order_text06: "请确认已收到相应款项，操作后资金将直接打给对方，有不可追回风险，慎重操作！",
    order_text07: "请联系客服获取",
    true_name: "对方姓名",
    confirmationReceipt: "确认已收款",
    confirmPayment: "确认已付款",
    importantNote: "重要提示",
    paymentAmount: "付款金额",
    amountCollected: "收款金额",
    accountNumber: "账号",
    realName: "实名",
    confirmCreate: "确认创建",
    failure: "失败",
    partialSuccess: "部分成功",
    forThePayment: "待付款",
    paymentHasBeen: "已付款",
    forCollection: "待收款",
    waiting_process: "等待处理",
    confirmReceipt: "确认收款",
    dealOrders: "成交订单",
    merchantOrder: "商家挂单",
    currentOrder: "当前挂单",
    completedOrder: "已完成订单",
    cancelledOrder: "已取消订单",
    buyer: "买家",
    seller: "卖家",
    moneyTotal: "金额",
    error_01: "不能大于数量",
    error_02: "最小交易量不能大于最大交易量",
    title_01: "请确认",
    text_04: "已实际订单为准",
    text_05: "交易方式",
    text_06: "确认下单",
    text_07: "申请成为商家",
    text_08: "请选择支付方式",
    text_09: "申请成为商家条件",
    text_10: "用户账号必须通过",
    text_11: "用户账号必须绑定",
    apply: "申请",
    allPay: "全部支付方式",
    pleaseEnter: "请输入",

    "PLEASE_VERIFY_YOUR_REALNAME": "请先实名认证",
    deal: '交易',
    tradingRecord: '交易记录',
    need: '需要',
    price: "价格",
    amount: "数量",
    time: "时间",
    action: "操作",
    type: "类型",
    orderID: "订单号",
    ToBuyImmediately: '立即买入',
    acquirability: '可得',
    ImmediatelySell: '立即卖出',
    purchases: '买入量',
    BuyQuantity: '买入量',
    SellQuantity: '卖出量',
    TradeShow: '买卖说明',
    explain_1: '买卖商户均为实地考察认证商户，并提供100万的USDT保证金，您每次兑换会冻结商户资产，商户资产不够时，不能接单，可放心兑换',
    explain_2: '买卖商户均为实名认证商户，并提供保证金，可放心兑换',
    explain_3: '请使用本人绑定的银行卡进行汇款，其他任何方式汇款都会退款。（禁止微信和支付宝）',
    explain_4: '商家处理时间9:00 - 21:00非处理时间的订单会在第二天9:00开始处理，一般接单后24小时内会完成打款',
    explain_5: '单天最多只能发起5笔未处理充值订单。',
    unitPrice: '单价',
    paymentInformation: '付款信息',
    orderInformation: "订单信息",
    moneyOrder: '汇款订单',
    ServiceProvider: "服务商信息",
    success: '成功',
    unfinished: "未完成",
    canceledCanc: '已取消',

    unconfirmed: "待确认",
    inhand: '处理中',
    haveExpired: '已过期',
    unpaid: '待支付',
    fBnak: "服务商开户行",
    fNumber: "服务商账号",
    name: '收款方户名',
    oBnak: '收款方开户行',
    number: '收款方账号',
    txt: '汇款时备注内容',
    must: '(请务必填写)',
    mobile: '收款方手机号码',
    HaveTransfer: '已转账',
    cancel: '取消',
    back: '返回',
    CancelWithdrawal: '取消提现',
    ToTransfer: '待转账',
    overdue: '过期',
    service: '服务商户名',
    snum: '服务商手机号',
    tacount: '转账金额',
    state: "状态",
    ordercancel: '订单已取消',
    orderdispose: '订单已提交处理',
    copysuccess: '复制成功',
    surecancel: '确定要取消吗?',
    depositsuccess: '提现成功，请等待服务商处理',
    untreated: '未处理',
    text_01: "数量不能大于余额",
    text_02: "请按提示信息向该卖家汇款",
    text_03: "（禁止使用支付宝和微信）",
    remark: "转账备注",
    required: "必填",
    WaitingTransfer: "待转账",
    buy_text01: "买入数量必须是100的倍数",
  },
  // 安全中心
  security: {
    LoginPasswordSetting: '登录密码设置',
    Certification: '实名认证',
    GoogleCertification: '谷歌认证',
    PaymentOfTheBinding: '支付绑定',
    verificationMode: '验证方式',
    BindingMobilePhone: '绑定手机',
    change: "更换",
    bind: "绑定",
    text_01: "请输入邮箱",
    text_02: "请输入正确的邮箱",
    oldPassword: "旧密码",
    newPassword: "新密码",
    payPassword: "资金密码",
    oldpayPassword: "旧资金密码",
    newpayPassword: "新资金密码",
    confirmPayPassword: "确认资金密码",
    payPasswprd_01: "请输入资金密码",
    payPasswprd_02: '请输入六位数纯数字资金密码',
    payPasswprd_03: '为了保证资金安全，请设置交易时输入资金密码',
    setSuccess: "设置成功",
    confirmPassword: "确认密码",
    email: "邮箱",
    mobile: "手机号码",
    password: "登录密码",
    email_text: "您绑定的邮箱为",
    mobile_text: "您绑定的手机号码为",
    password_text: "登录时使用",
    email_text_01: "您未绑定邮箱",
    mobile_text_01: "您未绑定手机号码",
    gender: "性别",
    man: "男",
    woman: "女",
    secret: "保密",
    immediatelyChange: "立即修改",
    modifySuccess: "修改成功",
    avatar: "头像",
    upload_text01: "上传图片只能是 JPG、JPEG、gif、bmp、PNG 格式!",
    username: "用户名",
  },
  // 密码验证
  password: {
    changePassword: '密码修改',
    PleaseEnterANewPassword: '请输入新密码',
    ConfirmNewPassword: '确认新密码',
    resetPasswords: '重置密码',
    passwordCannot: '密码不能小于8位',
    DifferentPasswords: '密码不相同',
    passwordEmpty: '密码不能为空'
  },
  // 实名认证 
  certification: {
    id_card: "身份证",
    Certification: '实名认证',
    ordinaryCertification: "普通认证",
    identity: "身份认证",
    identityContent: "为了您的账户安全，请完善身份认证",
    senior: "高级认证",
    seniorContent: "为了您的账户安全，请完善高级认证",
    senior_1: "请先完成身份认证，再进行高级认证",
    attestation: "立即认证",
    certified: "已认证",
    Credentials: '填写认证信息',
    results: "认证结果",
    inthereview: "审核中",
    hint: '上传身份证正反面（请确保照片的内容完整并清晰可见，身份证必须在有效期内）。手持本人身份证正面照和个人签字,个人签字的内容包含',
    realNames: '真实姓名',
    validID: '身份证号码',
    uploading: '上传证件信息（请确保清晰可见）',
    frontCard: '身份证正面',
    versoCard: '身份证反面',
    handCard: '手持身份证',
    signature: '和当前日期（请确保照片和个人签字的内容清晰可见）。',
    submit: '提交认证',
    AuditFailed: '审核未通过',
    cause: '原因:',
    revalidate: '重新验证',
    audit: '实名审核中......',
    pass: '认证成功',
    frontCardFailToUpload: '身份证正面上传失败',
    versoCardFailToUpload: '身份证反面上传失败',
    handCardFailToUpload: '手持身份证上传失败',
    realName: '请输入真实姓名',
    IDCard: '请输入身份证号码',
    await: '等待图片上传完成',
    submitSuccessfully: '提交成功',
    text_01: "恭喜你，完成了实名认证",
    text_02: "您的资料已提交审核，预计将在一个工作日内完成审核",
    text_03: "我们会保护您的个人信息安全,请您耐心等待！",
    text_04: "恭喜你，完成了高级认证",
    text_05: "信息不完整",
    IDType: "证件类型",
    step1: "上传有效证件",
    step2: "等待审核",
    step3: "完成高级认证",
    pRequire: "照片要求:",

  },
  // 谷歌认证
  Google: {
    otp: "谷歌认证",
    certified: "已认证",
    unverified: "未认证",
    authentication: '认证',
    copy: '复制',
    gcode: '请输入谷歌验证码',
    gopen: '开启Google认证',
    turned: '您已开启谷歌验证',
    change: '更改',
    gvcode: '谷歌验证码',
    gcancel: '取消谷歌验证',
    gnull: '谷歌验证码不能为空',
    pnull: '密码不能为空',
    gerr: '谷歌验证码错误',
    perr: '密码错误',
    bindSuccess: "绑定成功",
    unBindSuccess: "解绑成功",
    GoogleDownload: "下载谷歌验证器",
    step1: "第一步",
    step2: "第二步",
    step3: "第三步",
    key: "密钥:",
    text_01: "注意：此二维码以及密钥是获取谷歌验证码唯一标识，请勿泄漏。",
    text_02: "使用谷歌验证器扫描二维码或输入以下密钥",
    text_03: "部分安卓手机不支持扫描二维码,请选择输入密钥方式",
    text_04: "填写下方信息开启谷歌认证",

  },
  // 支付绑定
  pay: {
    Payment: '支付绑定',
    bank: '开户行名称',
    bCard: '银行卡卡号',
    change: '修改',
    confirm: '确定',
    addBank: "添加",
    delete: "删除",
    default: "默认卡",
    setDefault: "设为默认",
    branch: "分支行",
    account: "账号",
    weixin: "微信",
    alipay: "支付宝",
    bankCard: "银行卡",
    text_01: "请先完成实名认证",
    text_02: "暂未绑定银行卡",
    text_03: "确认删除此卡？",
    text_04: "确定设置为默认卡？",
    text_05: "确认关闭？",
    text_06: "收款方式",

    goCertification: "去认证",


  },
  // 验证方式
  vmode: {
    vmode: '验证方式',
    Passauth: '密码验证',
    gauth: '谷歌验证',
    eauth: '邮箱验证',
    mauth: '短信验证'
  },
  // 绑定手机
  bmobile: {
    bmobiles: '绑定手机',
    mnumber: '手机号码',
    pnum: '请输入手机号码',
    mauth: '短信验证码',
    gcode: '获取验证码',
    again: '秒后重新获取',
    unbind: '解绑',
    submit: '提交',
    correctnum: '请输入正确的手机号码',
    unbindsuccess: '解绑成功',
    bindsuccess: '绑定成功'
  },
  // 搜索
  search: {
    antistop: '请输入关键词',
    search: '搜索'
  },
  // 关注货币
  currency: {
    attention: '已关注币种',
    noattention: '未关注币种',
    currencyname: '输入币种名称实时过滤',
    acurrency: '关注币种',
    kind: '种'
  },
  // 身份验证
  showDialogs: {
    authentication: "身份验证",
    password: '密码',
    ppass: '请输入密码',
    gauth: '谷歌验证码',
    pgauth: '请输入谷歌验证码',
    eauth: '邮箱验证码',
    peauth: '请输入邮箱验证码',
    mauth: '手机验证码',
    pmauth: '请输入手机验证码',
    code: "验证码",
    pcode: "请输入验证码"
  },
  // 提币
  withdrawto: {
    address: '地址名称，如：我的地址1，选填',
    depositprice: '提现金额',
    inputprice: '请输入金额',
    usableprice: '可用余额：',
    mindeposit: '最低提现：',
    fee: '佣金',
    available: "可用余额",
    withdraw: "提现",
    cancel: "取消",
    withdrawAddress: "提币地址",
    withdrawAmount: "提现数量",
    text_01: "您尚未设置,点击添加提币地址",
    text_02: "提币地址不能为空",
    text_03: "请选择",
    text_04: "你确定删除该地址吗？",
    text_05: '链名称不能为空',
    addAddress: "添加提币地址",
    newAddress: "添加新地址",
    actual: "实际到账",
    sure: '确定',
    cannotbezero: "数量不能为0",
    codenull: '请输入验证码',
    minWithdrawal: "提现最低不能小于",
    deposit: '提币',
    or: '或',
    taccounts: '转帐',
    add: "添加新",
    edit: "修改",
    pinput: '请输入',
    depositadd: '提现地址',
    AddressNote: "地址备注",
    code: "验证码",
    getCode: "获取验证码",
    resend: "秒后可重发",
    raccount: '对方帐户',
    prompt: "提示",
    deleteSuccess: "删除成功",
    depositsuccess: '提现成功',
    addSuccess: "添加成功",
    editSuccess: "修改成功",
    addnull: '地址或提现金额不能为空',
    passerr: '密码错误',
    gerr: '谷歌验证码错误'
  },
  // 充值
  payto: {
    qrcode: '充值到二维码地址',
    copy: '复制',
    sweepcode: '扫一扫二维码',
    getadd: '获取充值地址',
    inputrecharge: '请输入充值金额',
    sure: '确认',
    hint: '输入要充值金额，过滤有充足资金的代理商（通过以下联系方式联系代理商帮你充值）',
    Rechargedefeated: '充值失败',
  },
  // 充值提现记录
  bill: {
    record: '充值提现记录',
    allrecord: '全部记录',
    rechargeRecord: '充值记录',
    withdrawRecord: '提现记录',
    ToAudit: '待审核',
    error: '错误',
    pulldown: '下划查看更多',
    nodata: '没有更多数据',
    loading: '加载中...'
  },
  // 锁仓
  lock: {
    time: "时间",
    lockName: "锁仓名称",
    coin: "币种",
    lockAmount: "锁仓数量",
    lockValue: "锁仓价值",
    status: "状态",
    action: "操作",
    add: "添加",
    upgrade: "升级",
    selectLock: "选择锁仓",
    status_01: "进行中",
    status_02: "已完成",
    lock: "锁仓",
    lockRules: "锁仓规则"
  },
  game: {
    game: '游戏',
    gameTips: '100%公平',
    available: "余额",
    rollDice: '投骰子',
    becomeDealer: '成为庄家',
    introduce: '玩法介绍',
    currentCoin: '当前币种',
    bettingAmount: '投注金额',
    winningAmount: '赢取金额',
    winVictory: '获胜',
    point: '点数',
    odds: '赔率',
    winningProbability: '中奖概率',
    user: '用户',
    luckyNumber: '幸运数',
    reward: '奖励',
    allBets: '所有投注',
    myBet: '我的投注',
    beADealer: '我要做庄',
    bonusPool: '奖金池',
    currentInvestment: '当前投资',
    bettingRatio: '投注占比',
    investedCoin: '投入币种',
    investment: '投入',
    withdrawalCoin: '撤出币种',
    step1: '1. 选择需要投注货币',
    step2: '2. 设置需要投注量',
    step3: '3. 调整滑条上的滑块位置，投注股子号码范围，改变胜出机率',
    step4: '4. 按下"投注"按钮进行投注，如果摇到股子号码在投注股子号码范围,立即中奖',
    moreThanBalance: '不能超出余额:',
    moreThanBets: '不能大于最大投注:',
    minimumbet: '不能小于最小投注:',
    win: '赢',
    lost: '输',
    withdrawal: '撤出',
    investmentSuccess: '投资成功',
    divestmentSuccess: '撤资成功',
    bet: "投注",
    profit: "利润",
    random: "换手气",
    dealer: "做庄",
    rule: "规则",
    my: "我的",
    website: "网站",
    multiple: "倍数",
    scope: "范围",
    AllBets: "所有投注",

    myBets: "我的投注",
    betInfo: "投注信息",
    serverSeed: "服务器种子",
    hash: "(散列)",
    customerSeed: "客户种子",

    serialNumber: "流水号",
    change: "更换",
    changeSuccess: "更换成功",

    serverHash: "服务端种子哈希",
    randomNumber: "随机数",
    rettingRecord: "投注记录",

    NotReleased: "未公布",
    fair_01: "1. 此游戏可由数学公式反向验证出来每一个掷出的随机点数都是公正的，营运方无法预先决定胜负结果。",
    fair_02: "2. 当你按下用户菜单栏里【换手气】按钮，系统将会产生一组服务器随机种子的SHA256散列值，再配合客户自行设定的 客户随机种子，及投注流水号， 我们将上述三个资料合并运算, 产生公正且随机的投注结果。",

  },
  // 炒币机器人
  financial: {
    old: "旧版",
    new: '新版',
    profitTop: "量化排行榜",
    dayStatistics: "日收益数据统计",
    returnsDetailed: "收益明细",
    coinTop: "收益币种排行榜",
    bigData: "智能量化大数据",
    day: "今日",
    month: "本月",
    all: "所有",
    my: "我的",
    platform: "平台",
    total: "总",
    pair: "交易对",
    uid: "用户ID",
    available: "可用",
    freeze: "冻结",
    destroy: "销毁",
    discuss: "交流",
    totalStatistics: "总量统计",
    fullscreen: "全屏模式",
    exitFullscreen: "退出全屏",
    quantize: "智能量化",
    dayProfit: "当日收益",
    totalRevenue: "累计收益",
    totalYield: "累计收益率",
    financial: "炒币机器人",
    EquipmentBind: "设备绑定：",
    IsBinding: "已绑定",
    AddRobot: "添加机器人",
    help: "帮助",
    text_01: "请登陆APP进行绑定!",
    RobotList: "机器人列表",
    grossProfit: "总利润：",
    IncomeRanked: "收益排行榜",
    market: "市场",
    buy: "已买入",
    revenue: "收益",
    Operations: "操作",
    grade: "等级",
    user: "用户",
    bet: "投注",
    profit: "收益",
    delete: "删除",
    add: "添加",
    robot: "机器人",
    edit: "修改",
    stop: "停止",
    start: "启动",
    exchange: "交易所",
    robotHistory: "机器人历史",
    robotResult: "机器人结果",
    setSuccess: "设置成功",
    exit: "是否退出",
  },
  // 推荐
  recommended: {
    title: "将推荐给您的朋友",
    history: "介绍的用户以及奖励",
    text_01: "对于每一个您推荐来的用户，我们将奖励您，具体奖励见公告。",
    text_02: "我们将为您单独生成一个链接，您可将此链接分享给您的朋友用以注册。系统将标识使用此链接注册的用户是您所推荐的。",
    text_03: "不允许传播任何误导消息或作出任何有损",
    text_03_1: "品牌的行为。",
    text_04: "对于滥用此推荐奖励机制的账户，我们将做冻结处理，且不会提前发出通知。",
    text_05: "您已阅读并同意了我们的使用条款和先决条件",
    account: "账户",
    reward: "奖励",
    addHistory: "添加记录",
    bonusHistory: "奖励记录",
    referrerUid: "好友ID",
    status: "状态",
    status_01: "已入帐",
    status_02: "未入帐",
  },
  // 币种介绍
  introduces: {

    coinIntroduction: "币种简介",

    link: "链接",

    parameter: "技术参数",

    ChineseName: "中文名",

    EnglishName: "英文名",

    EnglishAbbreviation: "英文简称",

    Developer: "开发者",

    BlockTime: "区块时间",

    DateIssue: "发布时间",

    CoreAlgorithm: "核心算法",

    MonetaryAggregates: "货币总量",
    whitePaper: "白皮书"
  },

  // 工单
  workOrder: {
    title: "问题标题",
    type: "类型",
    createTime: "创建时间",
    state: "状态",
    operation: "操作",
    view: "查看",
    close: "关闭",
    create: "创建工单",
    content: "内容",
    text_01: "请具体并准确的描述您的问题,这有助于我们更高效的帮助您!",
    text_02: "只能上传jpg/png/bmp/gif文件",
    text_03: "不能为空",
    upload: "上传附件",
    pending: "待处理",
    processing: "处理中",
    complete: "处理完成",
  },
  "ACCOUNT_HAS_BEEN_DISABLED": "账号被禁止",
  "DISABLE_LOGIN": "禁止登录",
  "TOO_MANY_INCORRECT_LOGIN_PASSWORD": "登录密码错误次数太多，请十分钟后再试",
  "GOOGLE_AUTHENTICATION_CODE_ERROR": "Google 验证码错误",
  "USER_DOES_NOT_EXIST": "用户不存在",
  "ACCOUNT_OR_PASSWORD_IS_INCORRECT": "账号或者密码错误",
  "PLEASE_RE-VERIFY": "请重新验证",
  "PLEASE_VERIFY_YOUR_REALNAME": "请先实名认证",
  "USER_NAME_TAKEN": "用户名已被使用",
  "MOBILE_EXISTS": "手机号已存在",
  "EMAIL_EXISTS": "邮箱已存在",
  "CODE_HAS_SEND": "验证码已发送请注意查收",
  "THE_PASSWORD_MUST_NOT_BE_LESS_THAN_8_BITS": "密码不能小于8位",
  "PARAMETER_ERROR": "不符合规范",
  "VERIFICATION_CODE_ERROR": "验证码错误",
  "INVALID_EMAIL": "无效的邮箱地址",
  "EMAIL_TAKEN": "邮箱已被使用",
  "MOBILE_TAKEN": "手机号已被使用",
  "INVALID_SMS_CODE": "验证码错误",
  "INVALID_NUMBER": "无效的手机号码",
  "INVALID_CAPTCHA": "错误的验证码",
  "ACCOUNT_ERROR": "账号错误",
  "BALANCE_NOT_ENOUGH": "余额不足",
  "SUCCESS": "成功",
  "PERMISSION_DENIED": "权限不足",
  "SEND_CODE_TOO_FAST": "发送验证码过快",
  "OPERATION_TOO_FAST": "操作过快",
  'PLEASE_LOGIN': '请登录',
  "WRONG_PASSWORD": '密码错误',
  "USERNAME_TAKEN": '用户名已被使用'
}



// WEBPACK FOOTER //
// ./src/common/language/zh.js